import { defineMessages } from "react-intl";

const messages = defineMessages({
  title: {
    id: "leadFinder.addRecordsWizard.title",
    defaultMessage: "Add {count} {count, plural, one {lead} other {leads}}",
    description: "Lead Finder - Add to Records modal title",
  },
});

export default messages;
